export default "__VITE_ASSET__DGY7eWME__"